import { configureStore } from "@reduxjs/toolkit";

import loaderSlice from "./slices/loaderSlice";

const store = configureStore({
  reducer: {
    loader: loaderSlice,
  },
});

export default store;
